import { buildProductCard } from "./etempa-build-klevu-product-card-v4.js";
import { buildArticleCard } from "./etempa-build-klevu-article-card-v5.js";
import { buildPagination } from "./etempa-build-klevu-pagination.js";
// NOTE: relative ES imports aren't fingerprinted by Shopify's asset_url, so the
// CDN serves them from a long-lived cache. Bump this ?v= whenever
// etempa-build-klevu-filters.js changes, or the old version keeps being served.
import { buildFilterBlock, createActiveFilters } from "./etempa-build-klevu-filters.js?v=2";
import { showLoadingSpinner, arrayChunk } from "./etempa-klevu-helpers.js";
import { etempaKlevuSendCategoryData } from "./etempa-klevu-analytics-v2.js";
import { setShowValue } from "./etempa-klevu-set-show-value.js";
import { buildSearchHeader } from "./etempa-klevu-build-search-header-v2.js";

const klevu_js_key = "klevu-163067900222714176";
const ENABLE_CMS_SEARCH = false; // Set to true if CMS indexing is turned on in Klevu and you want to show article results on the search results page
const no_results_elem = document.getElementById("etempa-product-grid-no-results");
const error_elem = document.getElementById("etempa-product-grid-error");
const error_text_elem = document.getElementById("etempa-product-grid-error-text");

// const product_grid_container = document.querySelector(".collection");
const unorderedList = document.getElementById("product-grid");

const pagination_container = document.querySelector(".pagination");
const paginationList = document.querySelector(".pagination__list");
const pagination_previous = document.querySelector(".pagination--previous");
const pagination_next = document.querySelector(".pagination--next");
// const pagination_items = document.getElementById("etempa-collection-pagination-pages");

const show_by_items = document.querySelectorAll(".utils-showby-item");
// const filter_form = document.querySelector("#FacetFiltersForm");
const sortBySelect = document.querySelector("[data-productgrid-trigger-sort]");
const mobile_filter_button = document.querySelector(".mobile-facets__disclosure");
const mobile_filter_text = mobile_filter_button.querySelector(".mobile-facets__open-label");
const priceData = {};
const filterMinMaxData = {};

const pageAbortController = new AbortController();
window.addEventListener("pagehide", () => pageAbortController.abort());

const sort_klevu_equivs = {
  manual: "RELEVANCE",
  "title-ascending": "NAME_ASC",
  "title-descending": "NAME_DESC",
  "price-ascending": "PRICE_ASC",
  "price-descending": "PRICE_DESC",
  "created-ascending": "NEW_ARRIVAL_ASC",
  "created-descending": "NEW_ARRIVAL_DESC",
};

let page = 1;
let limit = 36;
let view = "grid-view";
let sort = "manual";
let enabledFilters = [];
let currentFilters = [];

let priceRange = [];
let step;
let priceSlider;
let priceSliderContainer;
let searchQuery = "";
// let sliderInteraction = false;
let currencySymbol = "£";
let changeCurrency = false;
let modalFirstGroupHeightInterval;
let urlParams = new URLSearchParams(document.location.search);
if (urlParams.get("q")) searchQuery = urlParams.get("q");
if (urlParams.get("page")) page = Number(urlParams.get("page"));
if (urlParams.get("grid_list")) view = urlParams.get("grid_list");
if (urlParams.get("view")) limit = Number(urlParams.get("view").replace("view-", ""));
if (urlParams.get("sort_by")) sort = urlParams.get("sort_by");
currentFilters = urlParams.getAll("filter");

let cachedFilters =
  localStorage.getItem("klevuCollectionCachedFilters") != undefined
    ? JSON.parse(localStorage.getItem("klevuCollectionCachedFilters"))
    : {};
let lastInteraction = localStorage.getItem("klevuCollectionCachedInteraction");

if (cachedFilters?.collection_name != collection_name || currentFilters.length < 1) {
  cachedFilters = {};
  localStorage.removeItem("klevuCollectionCachedFilters");
  localStorage.removeItem("klevuCollectionCachedInteraction");
  lastInteraction = undefined;
}
cachedFilters.collection_name = collection_name;

getProducts(klevu_js_key);
setShowValue(show_by_items, limit, currentFilters, urlParams);
// mobileFilterButtonEvent();
// windowResizeEvent();
setupSortBySelectChangeEvent();

function setupSortBySelectChangeEvent() {
  if (sortBySelect) {
    sortBySelect.addEventListener("change", (e) => {
      e.preventDefault();
      sort = sortBySelect.value;
      window.location.href = buildHref(1);
    });
  }
}

function getProducts(klevu_js_key) {
  no_results_elem.style.display = "none";
  error_elem.style.display = "none";
  document.querySelector(".main-collection-container")?.classList.remove("main-collection-container--empty");

  if (!window.Shopify?.designMode) {
    document.querySelector("[id*='search-no-results-logos']")?.style.setProperty("display", "none");
    document.querySelector("[id*='search-no-results-recs']")?.style.setProperty("display", "none");
  }

  let request = {
    recordQueries: [
      {
        filters: {
          filtersToReturn: {
            enabled: true,
            exclude: ["variantid", "inventoryQuantity"],
            options: {
              order: "INDEX",
              limit: 999999,
            },
            rangeFilterSettings: [
              {
                key: "klevu_price",
                minMax: false,
                rangeInterval: 10,
              },
            ],
          },
        },
        id: "productList",
        typeOfRequest: "SEARCH",
        settings: {
          sort: sort_klevu_equivs[sort],
          query: {
            term: searchQuery,
          },
          typeOfRecords: ["KLEVU_PRODUCT"],
          limit: limit,
          offset: page > 1 ? limit * (page - 1) : 0,
          // groupCondition: {},
        },
      },
      ...(ENABLE_CMS_SEARCH
        ? [
            {
              id: "contentSearch",
              typeOfRequest: "SEARCH",
              settings: {
                typeOfRecords: ["KLEVU_CMS"],
                query: {
                  term: searchQuery,
                },
                limit: 10,
                offset: 0,
              },
            },
          ]
        : []),
    ],
    context: {
      apiKeys: [klevu_js_key],
    },
  };

  // console.log("HERE");
  // console.log(request);

  if (currentFilters.length > 0) {
    // -- NEW: applyFilters (recommended by Klevu support) --
    // applyFilters lives inside `filters` (alongside filtersToReturn), not inside `settings`
    request.recordQueries[0].filters.applyFilters = {
      filters: [],
    };
    // -- OLD: groupCondition --
    // request.recordQueries[0].settings.groupCondition = {
    //   groupOperator: "ALL_OF",
    //   conditions: [],
    // };
    // request.recordQueries[0].settings.applyFiltersForBoostedProducts = true;

    // Collect all selected price ranges to combine into a single min/max condition
    let priceRangeConditions = [];

    currentFilters.forEach((filter) => {
      let filterArray = filter.split("_");
      let filterKey = filterArray[0];
      let filterValue = decodeURIComponent(filterArray[1]);

      if (filterKey === "minMaxPrice") {
        let filterMin = Number(filterArray[1]);
        let filterMax = Number(filterArray[2]);
        priceRangeConditions.push({
          key: "klevu_price",
          values: [filterMin, filterMax],
          settings: { singleSelect: "false" },
        });
      } else {
        let filterExistsIndex =
          request.recordQueries[0].filters.applyFilters.filters.findIndex(
            (f) => f.key === filterKey,
          );
        if (filterExistsIndex > -1) {
          request.recordQueries[0].filters.applyFilters.filters[
            filterExistsIndex
          ].values.push(filterValue);
        } else {
          request.recordQueries[0].filters.applyFilters.filters.push({
            key: filterKey,
            values: [filterValue],
            settings: { singleSelect: "false" },
          });
        }
      }
    });

    // Combine all selected price ranges into a single min/max condition
    if (priceRangeConditions.length > 0) {
      let overallMin = Math.min(...priceRangeConditions.map((c) => c.values[0]));
      let overallMax = Math.max(...priceRangeConditions.map((c) => c.values[1]));
      // -- NEW --
      request.recordQueries[0].filters.applyFilters.filters.push({
        key: "klevu_price",
        values: [overallMin, overallMax],
        settings: { singleSelect: "false" },
      });
      // -- OLD --
      // request.recordQueries[0].settings.groupCondition.conditions.push({
      //   key: "klevu_price",
      //   valueOperator: "INCLUDE",
      //   singleSelect: false,
      //   values: [overallMin, overallMax],
      // });
    }
  }

  runKlevuQuery(request);
}

function runKlevuQuery(request) {
  console.log("REQUEST: ", request);
  fetch(`https://rwcsv2.ksearchnet.com/cs/v2/search`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    signal: pageAbortController.signal,
    body: JSON.stringify(request),
  })
    .then((response) => {
      // console.log("RESPONSE: ", response);
      console.log("RESPONSE.DATA search: ", response.json);
      return response.json();
    })
    .then((data) => {
      console.log("Search data: ", data);

      if (data.meta.responseCode === 200) {
        const contentResults = data.queryResults.find((q) => q.id === "contentSearch");
        const articleRecords = (contentResults?.records || []).filter((record) =>
          record.url?.includes("rarewaves"),
        );

        const articleGrid = document.getElementById("article-grid");
        const articleResults = document.getElementById("article-results");
        if (articleGrid) {
          articleGrid.innerHTML = "";
          articleRecords.forEach((article, index) =>
            buildArticleCard(article, articleGrid, "grid__item", searchQuery, index),
          );
        }
        if (articleResults) {
          articleResults.style.display = articleRecords.length > 0 ? "" : "none";
        }

        // Search header that shows number of results and search term
        const productTotal = data.queryResults[0]?.meta.totalResultsFound || 0;
        const articleTotal = contentResults?.meta.totalResultsFound || 0;
        buildSearchHeader(
          productTotal + articleTotal,
          data.queryResults[0]?.meta.searchedTerm || contentResults?.meta.searchedTerm || searchQuery,
        );
        if (data.queryResults[0]?.meta.noOfResults > 0 && data.queryResults[0].records.length > 0) {
          const allHandles = data.queryResults[0].records
            .filter((record) => {
              return record.url.includes("rarewaves");
            })
            .map((record) => {
              return record.url.split("/").pop();
            });
          const handles = arrayChunk(allHandles, 20);

          if (current_currency !== "GBP") {
            changeCurrency = true;
            let filterMax = 0;
            let filterMin = 0;
            data.queryResults[0].filters.forEach((filter) => {
              if (filter.key === "klevu_price" || filter.key === "Price Range") {
                filterMax = filter.max;
                filterMin = filter.min;
              }
            });

            handles.forEach((handleChunk, index) => {
              let cacheBustingString = (Math.random() + 1).toString(36).substring(7);
              fetch(
                `/?handles=${handleChunk.join("_")}&sections=etempa-currency-conversion&max=${filterMax}&min=${filterMin}&type=${cacheBustingString}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  signal: pageAbortController.signal,
                },
              )
                .then((sectionResponse) => sectionResponse.json())
                .then((sectionData) => {
                  // console.log("SECTION DATA: ", sectionData);
                  let tempElem = document.createElement("div");
                  tempElem.innerHTML = sectionData["etempa-currency-conversion"];
                  let priceInfoArray = tempElem.querySelectorAll(".currency-conversion-price-info");
                  let filterInfoElem = tempElem.querySelector(".currency-conversion-filter-info");
                  if (priceInfoArray && priceInfoArray.length > 0) {
                    currencySymbol = priceInfoArray[0].getAttribute("data-product-price")[0];
                    priceInfoArray.forEach((priceInfo) => {
                      priceData[parseInt(priceInfo.getAttribute("data-product-id").trim())] = {
                        price: priceInfo.getAttribute("data-product-price"),
                        comparePrice: priceInfo.getAttribute("data-product-compare-price"),
                      };
                    });
                  }
                  // console.log("PRICE DATA: ", priceData);
                  if (filterInfoElem) {
                    filterMinMaxData.max = Number(
                      filterInfoElem.getAttribute("data-filter-max").trim(),
                    );
                    filterMinMaxData.min = Number(
                      filterInfoElem.getAttribute("data-filter-min").trim(),
                    );
                  }
                })
                .catch((error) => {
                  if (error.name === "AbortError") return;
                  console.error(error);
                  error_elem.style.display = "block";
                  error_text_elem.innerText = error;
                });
            });
            let displayPriceDataCount = 0;
            const displayPriceData = setInterval(
              () => {
                // console.log('Object.keys(priceData).length', Object.keys(priceData).length)
                // console.log('allHandles.length',  allHandles.length);
                displayPriceDataCount++;

                if (
                  Object.keys(priceData).length == allHandles.length ||
                  displayPriceDataCount > 20
                ) {
                  clearInterval(displayPriceData);
                  constructProductsAndFilters(data);
                }
              },
              250,
              priceData,
              allHandles,
              data,
              displayPriceDataCount,
            );
          } else {
            constructProductsAndFilters(data);
          }

          if (
            data.queryResults[0]?.meta.noOfResults != data.queryResults[0]?.meta.totalResultsFound
          ) {
            // const pagination_container = document.querySelector(".pagination");
            // const paginationList = document.querySelector(".pagination__list");
            // const pagination_previous = document.querySelector(".pagination--previous");
            // const pagination_next = document.querySelector(".pagination--next");
            // // const pagination_items = document.getElementById("etempa-collection-pagination-pages");
            buildPagination(
              data.queryResults[0].meta.totalResultsFound,
              limit,
              page,
              paginationList,
              pagination_next,
              pagination_previous,
              pagination_container,
              buildHref,
            );
          } else {
            pagination_container.style.display = "none";
          }
        } else {
          pagination_container.style.display = "none";
          if (articleRecords.length === 0) {
            no_results_elem.style.display = "block";
            const queryEl = no_results_elem.querySelector("[data-no-results-query]");
            if (queryEl) queryEl.textContent = searchQuery;
            document.querySelector(".main-collection-container")?.classList.add("main-collection-container--empty");

            const logosSection = document.querySelector("[id*='search-no-results-logos']");
            if (logosSection) logosSection.style.display = "block";
            const recsSection = document.querySelector("[id*='search-no-results-recs']");
            if (recsSection) recsSection.style.display = "block";
            document.dispatchEvent(new CustomEvent("klevu:search-no-results"));
          }
        }
      } else {
        error_elem.style.display = "block";
        error_text_elem.innerText =
          "An error occurred while fetching search results. Please try again later.";
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      console.error(error);
      error_elem.style.display = "block";
      error_text_elem.innerText = error;
    });
}

function constructProductsAndFilters(data) {
  let results = data.queryResults[0].records.filter((record) => record.url.includes("rarewaves"));

  unorderedList.innerHTML = "";

  window.klevuProducts = [];
  const fragment = document.createDocumentFragment();

  results.forEach((product) => {
    let link = `/products/${product.url.split("/").pop()}`;
    const listItemClass = "grid__item";
    buildProductCard(
      collection_name,
      collection_handle,
      product,
      changeCurrency,
      priceData,
      currencySymbol,
      collection_section_id,
      departmentMetaObject,
      fragment,
      link,
      listItemClass,
    );
    window.klevuProducts.push(Number(product.id));
  });

  unorderedList.append(fragment);

  enabledFilters = [...(data.queryResults[0]?.filters || [])];
  // Klevu omits a filter type from its response once it's been applied as a condition.
  // Rebuild the filter list in the original cached order, restoring any missing active types.
  if (cachedFilters.filters?.length > 0) {
    const liveMap = new Map(enabledFilters.map((f) => [f.key, f]));
    const merged = cachedFilters.filters.map((cached) => liveMap.get(cached.key) || cached);
    // Append any brand-new filter types from Klevu not previously cached
    enabledFilters.forEach((liveFilter) => {
      if (!cachedFilters.filters.find((cf) => cf.key === liveFilter.key)) {
        merged.push(liveFilter);
      }
    });
    enabledFilters = merged;
  }

  const facetsWrapperDesktop = document.querySelector("#FacetsWrapperDesktop");
  const facetsWrapperMobile = document.querySelector("#FacetsWrapperMobile");
  if (facetsWrapperDesktop) {
    const activeSection = facetsWrapperDesktop.querySelector(".active-facets-desktop");
    Array.from(facetsWrapperDesktop.children).forEach((child) => {
      if (child !== activeSection) child.remove();
    });
  }
  if (facetsWrapperMobile) {
    const sortContainer = facetsWrapperMobile.querySelector(".mobile-facets__sort-container");
    Array.from(facetsWrapperMobile.children).forEach((child) => {
      if (child !== sortContainer) child.remove();
    });
  }

  let tmpCachedFilterArray = [];
  if (enabledFilters && Array.isArray(enabledFilters) && enabledFilters.length > 0) {
    let filtersToCache;
    enabledFilters.forEach((filter, index) => {
      filtersToCache = buildFilterBlock(
        filter,
        index,
        currentFilters,
        changeCurrency,
        filterMinMaxData,
        currencySymbol,
        priceRange,
        step,
        priceSlider,
        priceSliderContainer,
        // sliderInteraction,
        enabledFilters,
        cachedFilters,
        lastInteraction,
        buildHref,
        showLoadingSpinner,
      );
      if (filtersToCache != null) {
        tmpCachedFilterArray.push(filtersToCache);
      }
    });
    cachedFilters.filters = tmpCachedFilterArray.map((f) => ({
      ...f,
      options: f.options ? f.options.slice(0, 50) : f.options,
    }));
    try {
      localStorage.setItem("klevuCollectionCachedFilters", JSON.stringify(cachedFilters));
    } catch (e) {
      localStorage.removeItem("klevuCollectionCachedFilters");
    }
    createActiveFilters(
      currentFilters,
      enabledFilters,
      currencySymbol,
      buildHref,
      collection_handle,
      setMobileFilterText,
    );
  }

  etempaKlevuSendCategoryData();
}

function buildHref(targetPage) {
  let params = new URLSearchParams();
  params.append("q", searchQuery);
  params.append("page", targetPage);
  params.append("view", limit);
  params.append("grid_list", view);
  params.append("sort_by", sort);
  console.log("PARAMS: ", params);
  if (currentFilters.length > 0) {
    currentFilters.forEach((filter) => params.append("filter", filter));
  }
  let href = `/search?${params.toString()}`;
  return href;
}

function setMobileFilterText() {
  if (mobile_filter_text) {
    mobile_filter_text.innerText = `Filters (${currentFilters.length})`;
  }
}
